import store from "@/store";
import messages from "../languages/index";
let lang = localStorage.getItem("language");
export default {
  install(Vue) {
    Vue.prototype.$request = {
      get: async function(endpoint) {
        let data;
        store.commit("setFeedbackProgress", true);
        await Vue.prototype.$axios
          .get(endpoint)
          .then((resp) => {
            data = resp.data;
          })
          .catch(() => {});
        return data;
      },

      post: async function(endpoint, dataPost) {
        let data;
        store.commit("setFeedbackProgress", true);
        await Vue.prototype.$axios
          .post(endpoint, Vue.prototype.$formdata(dataPost))
          .then((resp) => {
            data = resp.data;
          })
          .catch((err) => {
            data = [];
            let statusCode = err.response.status;
            if (statusCode != 400 && statusCode != 401) {
              throw err;
            }
          });
        return data;
      },

      exportDoc: async function(
        endpoint,
        params,
        extension,
        range,
        exportName
      ) {
        const isZip = params.isZip;

        let data;
        store.commit("setFeedbackProgress", true);

        // Nomeando o arquivo a partir do range;
        let named;
        if (range && range.weekly_deal == 1) {
          named = messages[lang].weeklyCalculationReport;
        } else if (range && range.weekly_deal == 2) {
          named = messages[lang].currenccalculationReport;
        } else if (range && exportName) {
          const data_inicio = new Date(range.data_inicio).toLocaleDateString();
          const data_final = new Date(range.data_final).toLocaleDateString();
          named = `${messages[lang].report} ${data_inicio} - ${data_final} - ${exportName}`;
        } else if (range) {
          const data_inicio = new Date(range.data_inicio).toLocaleDateString();
          const data_final = new Date(range.data_final).toLocaleDateString();
          named = `${messages[lang].report} ${data_inicio} - ${data_final}`;
        } else {
          named = messages[lang].report;
        }

        delete params.isZip;

        await Vue.prototype.$axios
          .post(endpoint, Vue.prototype.$formdata(params), {
            responseType: "blob",
          })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;

            // Buscar filename no headers do response no membro "content-disposition"
            const filename = response.headers["content-disposition"]
              .split("filename=")[1]
              .replaceAll('"', "");

            // Descodificar a string
            const availableFileName = decodeURI(filename).replaceAll("+", " ");
            // Busca pelo filename restrito a esses endpoints por conta de
            // decodificação de filename mal efetuada em outros exports
            const availableEndpointsFileName = [
              "/colab/promotions/listPromotionsAdhesions",
              "/administrator/promotions/listPromotionsAdhesions",
              "/colab/promotions/listEntrysByUserPromos",
              "/administrator/promotions/listEntrysByUserPromos",
              "/administrator/cassino/gamesAgregation/listFreespinsUsers",
              "/colab/cassino/gamesAgregation/listFreespinsUsers",
            ];

            if (
              availableEndpointsFileName.includes(response.config.url) &&
              availableFileName
            ) {
              link.setAttribute("download", `${availableFileName}`);
            } else {
              link.setAttribute(
                "download",
                `${named}.${isZip ? "zip" : extension}`
              );
            }

            document.body.appendChild(link);
            link.click();
            data = [];
            return data;
          })
          .catch((err) => {
            data = [];
            const splitRouteName = endpoint.split("/");
            let statusCode = err.response.status;

            if (
              splitRouteName[splitRouteName.length - 1] ==
                "affiliateAnalyticsData" &&
              statusCode == 400
            ) {
              throw err;
            }

            if (statusCode != 400 && statusCode != 401) {
              throw err;
            }
          });
        return data;
      },
    };
  },
};
